export const DmeposAccountTypes = ['DMEPOS Provider'];